import {
  Carousel,
  CarouselControl,
  CarouselIndicators,
  Modal,
} from 'reactstrap';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  margin: 30px;
  display: flex;
  justify-content: space-between;
`;
export const CarouselStyled = styled(Carousel)`
  width: 100%;

  img {
    width: 500px;
  }
`;
export const CarouselControlStyled = styled(CarouselControl)`
  span {
    fill: #2ec9b7 !important;
    color: #2ec9b7 !important;
  }
`;
export const RatingContent = styled.div`
  background-color: #fff;
  width: 100%;
  min-height: 300px;
`;

export const RatingHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #424242;
  span {
    text-align: center;
  }
`;

export const RatingBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  color: #424242;

  button {
    width: 54px;
    height: 54px;
    border: 1px solid #fff;
    border-radius: 8px;
    color: #fff;
    font-size: 30px;
    font-weight: bold;

    :hover {
      transform: scale(1.1);
    }
  }
`;
export const CarouselIndicatorsStyled = styled(CarouselIndicators)`
  margin-bottom: 80px;
  button {
    background-color: #33333370 !important;
  }
`;
export const WppModal = styled(Modal)`
  .modal-content {
    width: 600px;
    border-radius: 10px;
  }

  img {
    border-radius: 10px;
  }

  h1 {
    margin: 20px 0;

    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    color: #000000;
    text-align: center;
  }

  p {
    width: 505px;
    margin: 0 auto;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
  }
`;

export const ReconnectButton = styled.button`
  width: 233px;
  height: 48px;
  line-height: 48px;
  background: #ff2c3a;
  border-radius: 5px;
  border: none;
  margin: 80px auto 20px;

  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: #ffffff;

  &:hover {
    color: #ffffff;
    text-decoration: none;
  }

  &:focus {
    color: #ffffff;
    text-decoration: none;
  }
`;
